<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Refund Charge'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>
    <ng-container *ngIf="loaded">

      <tidy-row [align]="'center'">
        <tidy-text
          [body]="('Refunding a charge back to ' | translate) +
          (clientName | titlecase)+
          ('\'s Card.' | translate)">
        </tidy-text>
        <tidy-text
          [body]="">
        </tidy-text>
      </tidy-row>

      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              formControlName="amount"
              inputMode="numeric"
              [label]="('Amount to refund (up to ' | translate) + (refundable?.amount_to_refund | tcurrency) + ')'"
              [form]="form.controls.amount"
              [icon]="'assets/svg/cash.svg'"
              [activeIcon]="'assets/svg/cash-tidy-green.svg'"
              [mask]="'currencyMask'"
              [type]="'text'"
              [submitted]="submitted"
              [errorMessage]="'Please enter the amount to refund.'">
            </tidy-input>
          </tidy-row>
          <tidy-row>
           <tidy-textarea
             formControlName="reason"
             [form]="form.controls.reason"
             [label]="'Why are you refunding?'"
             [submitted]="submitted"
             [icon]="'assets/svg/information-circle-outline.svg'"
             [errorMessage]="'Please enter the reason.'">
           </tidy-textarea>
         </tidy-row>
        </form>
      </tidy-card>

      <tidy-error-message
        *ngIf="errorMessage"
        [text]="errorMessage">
      </tidy-error-message>

      <tidy-button
        [text]="'Submit Refund'"
        [action]="refundCharge.bind(this)"
        class="primary">
      </tidy-button>

    </ng-container>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
